import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { createRestoreArchivedActivityCommand } from '../../api/commands/factory/createActivityCardArchiveCommands';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { ForceRefreshStorymap } from './forceRefreshStorymap';
import { SetActiveCardIdByClick } from './cardSelection/setActiveCardIdByClick';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class RestoreArchivedActivity extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'RestoreArchivedActivity';

    public constructor(public id: string, public activityTitle: string) {
        super(RestoreArchivedActivity.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: RestoreArchivedActivity): Promise<boolean> => {
    await useSendCommandAsync(action, {
        createCommand: async () => await createRestoreArchivedActivityCommand(action),
    });

    await dispatch(new ForceRefreshStorymap());

    await dispatch(new SetActiveCardIdByClick(action.id));

    return true;
};

const reducer = (): void => {
    // @ts-ignore
};

//@ts-ignore
registerMiddleware(RestoreArchivedActivity.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(RestoreArchivedActivity.ACTION_TYPE, reducer);
